<template>
  <div class="equipment-exhibition">
    <el-table
      :data="filterEquipmentList"
      :class="{ noData: filterEquipmentList.length == 0 }"
      :row-class-name="tableRowClassName"
      style="width: 100%">
       <i
        slot="empty"
        style="font-size:16px;
        color:#6baae6;
        "
      >
        <img src="../../assets/icon_data_empty.png" alt="" />
        <span>暂无数据</span>
      </i>
      <el-table-column
        prop="name"
        label="名称"
        align="center"
        show-overflow-tooltip
        width="">
      </el-table-column>
      <el-table-column
        prop="base"
        label="基地"
        align="center"
        show-overflow-tooltip
        width="">
      </el-table-column>
      <el-table-column
        prop="pond"
        align="center"
        show-overflow-tooltip
        label="塘口">
      </el-table-column>
      <el-table-column
        prop="do"
        align="center"
        label="溶解氧">
      </el-table-column>
      <el-table-column
        align="center"
        prop="waterTemp"
        label="水温">
      </el-table-column>
      <el-table-column
        prop="ph"
        align="center"
        label="PH值">
      </el-table-column>
      <el-table-column
        prop="oxidation"
        align="center"
        label="氧化电还原">
      </el-table-column>
      <el-table-column
        prop="line"
        align="center"
        label="状态">
      </el-table-column>
      <el-table-column label="操作" align="center" width="170">
        <template slot-scope="scope">
          <span class="content-check" @click="check(scope.$index, scope.row)">查看</span>
        </template>
      </el-table-column>
    </el-table>
    <!-- <page-change :pageInfo="pageInfo"></page-change> -->
  </div>
</template>

<script>
import PageChange from '../../components/common/PageChange'
import indexModule from '../../store/modules/index'
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'EquipmentExhibition',
  components: {
    PageChange
  },
  data () {
    return {
      tableData: [
        {
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市'
        },
        {
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普'
        },
        {
          date: '2016-05-01',
          name: '王小虎',
          address: '上海市普'
        },
        {
          date: '2016-05-03',
          name: '王小虎',
          address: '上海'
        }
      ],
      pageInfo: {
        pageNumber: 1, // 当前页数
        totalPages: 0, // 总页数
        // pageFunc: this.getPondData, // 当前页数需要调用的函数
        pageSize: 10 // 当前页数
      }
    }
  },
  computed: {
    ...mapState(indexModule, ['equipmentList', 'equipmentId']),
    filterEquipmentList () {
      this.equipmentList.map(function (item) {
        if (item.online === false) {
          item.line = '离线'
        } else {
          if (item.powerStatus === 1) {
            item.line = '在线(电源供电)'
          } else {
            item.line = '在线(电池供电)'
          }
        }
        return item
      })
      return this.equipmentList
    }
  },
  methods: {
    ...mapMutations(indexModule, ['setSelectedEquipmentId']),
    // 查看
    check (index, row) {
      this.$router.push({
        name: 'Index'
      })
      this.setSelectedEquipmentId(row.id)
    },
    // 根据选中设备Id动态添加样式
    tableRowClassName (row, index) {
      if (row.row.id === this.equipmentId) {
        return 'info-row'
      }
      return ''
    }
  }
}
</script>
<style lang="stylus">
  .el-table {
    border-top: none;
    .el-table__empty-text {
      i {
        margin-top: 113px;
        img {
          display: block;
          width: 228px;
          height: 218px;
        }
        span {
          display: block;
          margin-top: 10px;
        }
      }
    }
  }
.equipment-exhibition

  .noData
    height: 540px;

  .el-table
    color: white;
    background: rgba(22, 75, 153, 0.1);

  .el-table .info-row
    background: rgba(4, 81, 174, 0.35)!important;

.equipment-exhibition .el-table .el-table__row .content-check
  margin-right: 0;

</style>
